<template>
  <div class="card">
    <div class="card-header">
      <h6>Crear Nuevo Agente</h6>
    </div>
    <div class="card-body px-4">
      <div class="row">
        <div class="col">
          <label>Nombre</label>
          <input type="text" class="form-control" v-model="form.name">
          <label>Email</label>
          <input type="text" class="form-control" v-model="form.email">
          <label>Identificacion</label>
          <input type="text" class="form-control" v-model="form.identification">
        </div>
        <div class="col">
          <label>Telefono (Sin espacios. Todo el numero pegado)</label>
          <input type="text" class="form-control" v-model="form.phone">
          <label>Contraseña</label>
          <input type="text" class="form-control" v-model="form.password">
          <label>IP autorizada (opcional)</label>
          <input type="text" class="form-control" v-model="form.allowed_ip" placeholder="Ej: 190.120.10.5">
          <button class="btn bg-gradient-success mt-4 w-100" @click="create"> Crear nuevo agente </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {post} from "@/utils/httpRequest";

export default {
  name: "create-agent",
  data: () => ({
    form: {
      name: '',
      email: '',
      identification: '',
      phone: '',
      password: '',
      allowed_ip: '',
    }
  }),
  methods: {
    async create(){
      if(this.form.name !== '' &&
          this.form.identification !== '' &&
          this.form.phone !== '' &&
          this.form.password !== '' &&
          this.form.email !== ''
      ){
        this.form.name = this.form.name.trim().toLowerCase();
        this.form.email = this.form.email.trim().toLowerCase();
        const {data} = await post('users/create-agent', this.form)
        if(data === 200){
          this.$swal({
            html: 'Agente creado correctamente',
            icon: 'success',
            timer: 2000,
            showCancelButton: false,
            showConfirmButton: false,
          });
          this.clearForm()
        }else{
          this.$swal({
            html: data.message || 'No se pudo crear el agente',
            icon: 'error',
            timer: 2500,
            showCancelButton: false,
            showConfirmButton: false,
          });
        }
      }else{
        this.$swal({
          html: 'Todos los campos son requeridos',
          icon: 'error',
          timer: 2000,
          showCancelButton: false,
          showConfirmButton: false,
        });
      }
    },
    clearForm(){
      this.form = {
        name: '',
        email: '',
        identification: '',
        phone: '',
        password: '',
        allowed_ip: '',
      }
    }
  }
}
</script>
<style scoped lang="scss">
</style>
